import React, { useEffect } from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import { ServiceTypes } from '../../../pages/OrderCheckout/utils/checkoutUtils';
import { getCollectionIcon } from '../../../pages/RestaurantMenu/utils/locationHeaderUtils';
import {
  LocationArea,
  PickupLocationType,
  TableServiceCategory,
} from '../../../weborder/Api';
import { Typography } from '../../atoms';
import { LoadingSpinner } from '../../layouts';
import { InlineBulletList } from '../../molecules';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      margin: 0,
    },
  },
  title: {
    display: 'inline-flex',
  },
  titleIcon: {
    alignSelf: 'center',
    marginRight: theme.spacing(1.25),
  },
}));

type Props = {
  editPickupLocationType?: (vrid: number, type: PickupLocationType) => void;
  locationAreas?: LocationArea[];
  physicalRestaurantAddress?: string;
  pickupLocationType?: PickupLocationType;
  restaurantNotes?: string[];
  serviceTypes: ServiceTypes;
  tableNumber?: number;
  tableServiceCategory: TableServiceCategory;
  translate: any;
  vrid: number;
};

export function TableNumberHeader(props: Props): JSX.Element {
  const {
    editPickupLocationType,
    locationAreas,
    physicalRestaurantAddress,
    pickupLocationType,
    restaurantNotes,
    serviceTypes,
    tableNumber,
    tableServiceCategory,
    translate,
    vrid,
  } = props;

  const classes = useStyles();
  const serviceIcon = getCollectionIcon(true, tableServiceCategory);

  useEffect(() => {
    if (
      editPickupLocationType &&
      pickupLocationType === PickupLocationType.TakeOut
    ) {
      if (serviceTypes.isDineInAndTakeOut) {
        editPickupLocationType(vrid, PickupLocationType.DineIn);
      } else {
        editPickupLocationType(vrid, PickupLocationType.TableService);
      }
    }
  }, []);

  const getHeaderText = (): string => {
    let title = `${translate(
      `Table_${tableServiceCategory}`,
    )} ${tableNumber.toString()}`;

    locationAreas?.forEach((locationArea) => {
      const hasMatchedLocation = locationArea.Locations.find(
        (location) => location.LocationId === tableNumber,
      );
      if (hasMatchedLocation) {
        title = `${hasMatchedLocation.LocationName} - ${locationArea.LocationAreaName}`;
      }
    });

    return title;
  };

  const loading = !locationAreas || !tableNumber;

  return (
    <div className={classes.header}>
      {loading ? (
        <LoadingSpinner variant="inline" />
      ) : (
        <>
          <div className={classes.title}>
            <div className={classes.titleIcon}>{serviceIcon}</div>
            <Typography variant="h3">{getHeaderText()}</Typography>
          </div>
          {restaurantNotes?.length > 0 && (
            <InlineBulletList notes={restaurantNotes} />
          )}
          {physicalRestaurantAddress && (
            <Typography variant="body2-secondary">
              {physicalRestaurantAddress}
            </Typography>
          )}
        </>
      )}
    </div>
  );
}
